import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import moment from "moment";
import { Markup } from "interweave";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Tooltip from "@mui/material/Tooltip";
import axiosApiInstance from "../axios";
import Modal from "react-modal";
import "./AllArticle.css";
import { Button, CircularProgress, LinearProgress } from "@mui/material";


const AllArticle = ({ term, categoryName, searchedItem }) => {

  const [higherRole, setHigherRole] = useState("");

  const fetchedRole=localStorage.getItem('userRole')

  useEffect(() => {
    if (fetchedRole?.includes("TMS-UI-Admin")) {
      setHigherRole("TMS-UI-Admin");
    } else {
      setHigherRole("");
    }
  }, [])
  

  const navigate = useNavigate();
  const [stopPagination, setStopPagination] = useState(false);
  const [loadNew, setLoadNew] = useState(true);
  const [loading, setLoading] = useState(true);
  const [showArt, setShowArt] = useState([]);
  const [searchedArticle, setSearchedArticle] = useState([]);
  const [loadingsearchedArticle, setLoadingSearchedArticle] = useState(true);

  const [isOpen, setIsOpen] = useState(false);
  const [openDeleteMsg, setOpenDeleteMsg] = useState(false);
  const [articleId, setArticleId] = useState("");


  const limit = 7;
  let pageNumber = 1;
  let scrollDebounce = false;
  const loadNext = () => {
    if (!stopPagination) {
      axiosApiInstance.get(`/article/${pageNumber}/${limit}`).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          if (res.data.data.length < limit) {
            setStopPagination((prevValue) => {
              return true;
            });
          }

          setShowArt((prevState) => [...prevState, ...res.data.data]);
          pageNumber += 1;
        }
      });
    }
  };

  const scrollHandle = (e) => {
    if (
      window.innerHeight + e.target.documentElement.scrollTop + 1 >=
        e.target.documentElement.scrollHeight &&
      !stopPagination &&
      !scrollDebounce
    ) {
      scrollDebounce = true;
      loadNext();
      setLoadNew(true);
      setTimeout(function () {
        scrollDebounce = false;
      }, 2000);
    }
  };

  setTimeout(() => {
    setLoadNew(false);
  }, 1000);

  useEffect(() => {
    loadNext();
    window.addEventListener("scroll", scrollHandle);
    return () => {
      window.removeEventListener("scroll", scrollHandle);
    };
  }, [stopPagination, isOpen]);

  useEffect(() => {
    if (searchedItem.length > 0) {
      setSearchedArticle([...searchedItem])
      setLoadingSearchedArticle(false)
    }
  }, [searchedItem]);

  const handleclick = (id) => {
    setIsOpen(true);
    setArticleId(id);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const closeDeleteModal = () => {
    setOpenDeleteMsg(false);
  };

  const SaveModal = () => {
    let id = articleId;
    axiosApiInstance
      .delete(`/article/${id}`)
      .then((res) => {
        if (res?.data?.succeeded === true) {
          setShowArt(showArt.filter((x) => x.id !== id));
          //  setTicketAttachments(ticketAttachment);
          //   setShowArt(showArt.filter(x => x.id !== id))
          setIsOpen(false);
          setOpenDeleteMsg(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  return (
    <>
      {categoryName?.length === 0 ? (
        <h3 className="k-all-article-head">All Article</h3>
      ) : (
        <>
          <h3 className="k-all-article-head">{categoryName !== 'All' ? categoryName : null} All Article</h3>
        </>
      )}

      <div className="k-base-article">
        <div className="k-article">

        {searchedItem.length > 0 ?
            searchedArticle.filter((show) => {
              
              if (categoryName.length === 0) {
                return show;
              } else {
                const length = show?.category?.length;
                let i;
                for (i = 0; i < length; i++) {
                  return show.category[i] === categoryName;
                }
                
              }
            }).map((show, id) => (
                <div>
                    {loadingsearchedArticle ? <CircularProgress/> : <>
                    <div className="k-all-article">
                   
                    <div
                      className="k-div-right"
                      onClick={() => navigate(`/Article/${show.id}`)}
                      key={id}
                    >
                      <div className="k-div-right-first">
                        <p className="k-id">{show.id}</p>
                        <p className="k-date">
                          {moment(show.createdDate).format("MMMM Do YYYY")}
                        </p>
                      </div>
                      <span>{show.title}</span>

                      <div className="desc">
                        <Markup content={show.description} />
                      </div>
                    </div>
                    <div className="k-moreIcon">
                      {higherRole === "TMS-UI-Admin" ? (
                        <>
                          <Tooltip title="Delete" arrow>
                            <MoreVertIcon
                              onClick={() => {
                                handleclick(show.id);
                              }}
                            />
                          </Tooltip>
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                    </>}
                  
                </div>
              )) :  <> {showArt &&
                showArt
                  .filter((show) => {
                    if (show?.id?.toLowerCase()?.includes(term.toLowerCase())) {
                      return show;
                    } else if (
                      show?.title?.toLowerCase()?.includes(term.toLowerCase())
                    ) {
                      return show;
                    }
                  })
                  .filter((show) => {
                    if (categoryName === 'All' || categoryName.length === 0) {
                      return show;
                    } else {
                      const length = show?.category?.length;
                      let i;
                      for (i = 0; i < length; i++) {
                        return show.category[i] === categoryName;
                      }
                      
                    }
                  })
                  .map((show, id) => (
                    <div>
                       
                      <div className="k-all-article">
                        <div
                          className="k-div-right"
                          onClick={() => navigate(`/Article/${show.id}`)}
                          key={id}
                        >
                          <div className="k-div-right-first">
                            <p className="k-id">{show.id}</p>
                            <p className="k-date">
                              {moment(show.createdDate).format("MMMM Do YYYY")}
                            </p>
                          </div>
                          <span>{show.title}</span>
    
                          <div className="desc">
                            <Markup content={show.description} />
                          </div>
                        </div>
                        <div className="k-moreIcon">
                          {higherRole === "TMS-UI-Admin" ? (
                            <>
                              <Tooltip title="Delete" arrow>
                                <MoreVertIcon
                                  onClick={() => {
                                    handleclick(show.id);
                                  }}
                                />
                              </Tooltip>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  ))}</>}
        
         
          <Modal
            isOpen={isOpen}
            ariaHideApp={false}
            onRequestClose={closeModal}
            contentLabel="Modal"
            className="modal-popup"
            shouldCloseOnOverlayClick={false}
          >
            <p className="Modal-open-text">
            Are you sure you want delete <span>{articleId}</span> Article?
            </p>

            <div className="delete-art">
              <Button className="delete-art-save" onClick={SaveModal}>
              DELETE
              </Button>
              <Button className="delete-art-close" onClick={closeModal}>
               CANCEL
              </Button>
            </div>
          </Modal>

          <Modal
            isOpen={openDeleteMsg}
            ariaHideApp={false}
            onRequestClose={closeDeleteModal}
            contentLabel="Modal"
            className="modal-popup"
            shouldCloseOnOverlayClick={false}
          >
            <p className="Modal-open-text">
              Article <span>{articleId}</span> deleted successfully!{" "}
            </p>
            <div className="delete-art">
              <Button className="delete-art-close" onClick={closeDeleteModal}>
                CLOSE
              </Button>
            </div>
          </Modal>
        </div>
      </div>
    </>
  );
};

export default AllArticle;
